import React from "react";
import FormHC from "../components/form";
import PortafolioComponent from "../components/PortafolioComponent";

function Portafolio() {
    return (
        <>
        <main>
            <PortafolioComponent />
            <FormHC />
        </main>
        </>
    );
}

export default Portafolio;